import React from "react";
import {
  Stack,
  Flex,
  Box,
  Heading,
  BoxProps,
  Collapse,
} from "@chakra-ui/react";

import Arrow from "components/Chakra/Icons/ArrowDown";
import Success from "components/Chakra/Icons/SuccessCircle";
import useViewport from "hooks/useViewport";

const ArrowBlock: React.FC<{
  text: React.ReactNode;
  title: string;
  noIcon?: boolean;
  arrowColor?: BoxProps["bgColor"];
}> = ({ text, title, noIcon, arrowColor }) => {
  const [open, setOpen] = React.useState(false);
  const { isMobile } = useViewport();

  return (
    <Stack
      w="100%"
      py="20px"
      alignItems="center"
      borderColor="ud-blue-100"
      borderBottomWidth="1px"
      wrap="nowrap"
      cursor="pointer"
      onClick={() => {
        setOpen((s) => !s);
      }}
      justify="center"
      spacing="0"
    >
      <Stack
        justify="space-between"
        alignItems="center"
        direction="row"
        w="100%"
      >
        <Stack direction="row" align="center" spacing="8px">
          {!noIcon && <Success boxSize="20px" fillWith="ud-success" />}
          <Heading as="h3" variant="h3_1">
            {title}
          </Heading>
        </Stack>
        <Arrow
          boxSize="33px"
          transform={open ? "rotate(180deg)" : undefined}
          transition="all 0.3s"
          fillWith={arrowColor || "ud-grey-300"}
        />
      </Stack>
      <Collapse in={open} animateOpacity>
        <Box
          mt="10px"
          pl={noIcon ? undefined : "29px"}
          pr={isMobile ? "10%" : "35%"}
        >
          {text}
        </Box>
      </Collapse>
    </Stack>
  );
};

const ArrowList: React.FC<{
  items: Array<{ title: string; text: React.ReactNode }>;
  noIcon?: boolean;
  arrowColor?: BoxProps["bgColor"];
}> = ({ items, noIcon, arrowColor }) => (
  <Flex direction="row" justify="center">
    <Stack
      w="100%"
      justify="center"
      direction="column"
      alignItems="center"
      spacing="0px"
    >
      {items.map((e) => (
        <ArrowBlock
          key={e.title}
          text={e.text}
          title={e.title}
          arrowColor={arrowColor}
          noIcon={noIcon}
        />
      ))}
    </Stack>
  </Flex>
);

export default ArrowList;
